<template>
<div>
  <v-card>
    <v-card-title class="pa-0 pl-2">
      <v-row>
        <v-col cols="12" sm="3">
          <v-select outlined hide-details dense :items="listOfMailBoxForFilter" item-text="mailboxname" item-value="mailboxid" label="Mailbox" v-model="mailbox"></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <div v-if="showNewTicketBanner">
            <v-banner single-line style="border: 1px solid #dcd6d6;" class="pa-0 newticket-banner">
              <v-icon slot="icon" color="primary" size="36">
                mdi-information-outline
              </v-icon>
              <span style="font-size: medium;">{{ $t('message.tickets.latestContentFound')  }}</span>
            <template v-slot:actions>
              <v-btn color="primary" text @click="loadTicketHandler">
                {{ $t('message.common.reload') }}
              </v-btn>
            </template>
          </v-banner>
          </div>
        </v-col>
        <v-col cols="12" sm="6" class="">
          <v-layout row wrap class="mx-0 text--right">
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''" dark @click="loadTicketHandler" class="mx-1">
              <v-icon>mdi-refresh</v-icon>
              {{ $t('message.tickets.refreshTickets') }}
            </v-btn>
            <v-btn color="primary" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''" dark @click="$router.push({ path: '/tickets/create', query: { type: 'task' } })" class="mx-3">{{ $t('message.tickets.createTask') }}</v-btn>
            <v-btn color="primary" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''" dark @click="$router.push('/tickets/create')" class="mx-3">{{ $t('message.tickets.createTicket') }}</v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs  }">
                <v-btn class="mx-3 mr-5" color="primary" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''" dark v-on="on" outlined  v-bind="attrs">{{$t('message.tickets.actions')}}<v-icon>mdi-menu-down</v-icon></v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in menuList" :key="index" @click="menuActions(item.value)">
                  <v-list-item-icon><v-icon v-text="item.icon" medium></v-icon></v-list-item-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-layout>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-tabs fixed-tabs dark v-model="selectedTab">
        <v-tab v-for="item in tabItem" :key="item.id" :href="'#tab-'+item.id" :disabled="istabDisabled">
          <v-icon small class="mr-3">{{item.icon}}</v-icon>
          {{ item.text }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <ticket-tabitem :selectedTabId="selectedTab" ref="tabitem" :key="reRender" :mailbox="mailbox"></ticket-tabitem>
      </v-tabs-items>
    </v-card-text>
  </v-card>
  <!--Merge Ticket-->
  <v-dialog v-model="mergeTicketDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.tickets.ticketMerge') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.tickets.chooseParentTicket') }}
          <v-radio-group v-model="parentticketid">
            <template v-for="(items, index) in mergeItems">
              <v-radio :label="items.number ? `${items.number} ${items.subject}`: `${items.subject}`" :value="items.id" :key="index"></v-radio>
            </template>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="merge" @click="mergeTicketHandler">{{ $t('message.tickets.merge') }}</v-btn>
          <v-btn color="primary" id="mergeclose" @click="closeMergeDialogHandler">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Status bulk change-->
    <v-dialog v-model="statusDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.tickets.changeStatus') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-autocomplete v-model="changedStatusId" :items="listOfTicketStatus" item-text="name" item-value="id" :placeholder="$t('message.tickets.status')" hide-details outlined dense></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="status" @click="changedStatusHandler()" :loading="statusLoading">{{ $t('message.common.update') }}</v-btn>
          <v-btn color="primary" id="statusclose" @click="closeStatusDialogHandler">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Priority bulk change-->
    <v-dialog v-model="priorityDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.tickets.changePriority') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-autocomplete v-model="changedPriorityId" :items="listOfTicketPriorities" item-text="name" item-value="id" :placeholder="$t('message.tickets.priority')" hide-details outlined dense></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="priority" @click="changedPriorityHandler">{{ $t('message.common.update') }}</v-btn>
          <v-btn color="primary" id="priorityclose" @click="closePriorityDialogHandler">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Assinged bulk change-->
    <v-dialog v-model="assignedDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.tickets.changeAssignedTo') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-autocomplete v-model="assignedtoId" :items="usersAndGroupsList" item-text="fullname" item-value="alternateid" :placeholder="$t('message.tickets.assignedTo')" hide-details outlined dense></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="priority" @click="changeAssignedtoHandler">{{ $t('message.common.update') }}</v-btn>
          <v-btn color="primary" id="priorityclose" @click="closeAssignedtoDialogHandler">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Delete-->
    <v-dialog v-model="deleteDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.tickets.deleteConfirm') }}
          <v-checkbox v-model="deleteMails" :label="$t('message.tickets.deleteMailsTo')" v-if="userDetails.role === 1"></v-checkbox>
          <span v-if="deleteMails" color="error">
           {{$t('message.tickets.note')}} : <code>{{$t('message.tickets.deleteNote')}}</code>
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="priority" @click="deleteHandler">{{ $t('message.common.delete') }}</v-btn>
          <v-btn color="info" id="priorityclose" @click="closeDeleteDialogHandler">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <!-- Status close confirm -->
    <v-dialog v-model="cancloseDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
         {{$t('message.invoice.confirmation')}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          Are you sure want to change status ?
          <p color="error">
           {{$t('message.tickets.note')}} : <code>Ticket will be Archived</code>
          </p>
          <h4 v-if="!archiveItem.assignedto">{{ $t('message.tickets.noUserAssigned') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" id="priority" @click="changedStatusHandler(true)" :loading="cancloseLoading">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="error" id="priorityclose" @click="closeConfirmDialog">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
export default {
  data () {
    return {
      data: '',
      reRender: 0,
      selectedTab: window.localStorage.getItem('tickettab') ? window.localStorage.getItem('tickettab') : 'tab-0',
      total: 0,
      mergeItems: [],
      loading: false,
      MODULE_URL: 'tickets',
      parentticketid: 0,
      mergeTicketDialog: false,
      statusDialog: false,
      priorityDialog: false,
      assignedDialog: false,
      changedStatusId: 0,
      changedPriorityId: 0,
      assignedtoId: 0,
      deleteMails: false,
      deleteDialog: false,
      selected: [],
      cancloseDialog: false,
      statusLoading: false,
      cancloseLoading: false,
      mailbox: window.localStorage.getItem('ticketmailbox') ? parseInt(window.localStorage.getItem('ticketmailbox')) : 0,
      archiveItem: {},
      usersAndGroupsList: [],
      istabDisabled: false,
      showNewTicketBanner: false
    }
  },
  components: {
    'ticket-tabitem': () => import('./TabItem')
  },
  computed: {
    ...mapState(['listOfUserGroupMailboxes', 'listOfTicketPriorities', 'listOfTicketStatus', 'userDetails', 'listOfUsers']),
    menuList () {
      return [
        { title: this.$t('message.tickets.merge'), value: 'merge', icon: 'mdi-call-merge' },
        { title: this.$t('message.tickets.changeStatus'), value: 'changeStatus', icon: 'mdi-priority-low' },
        { title: this.$t('message.tickets.changePriority'), value: 'changePriority', icon: 'mdi-currency-sign ' },
        { title: this.$t('message.tickets.assignTo'), value: 'assignTo', icon: 'mdi-account-circle' },
        { title: this.$t('message.tickets.delete'), value: 'delete', icon: 'mdi-delete' }
      ]
    },
    tabItem () {
      return [
        { id: 0, text: this.$t('message.tickets.allActive'), icon: 'mdi-pin' },
        { id: 1, text: this.$t('message.tickets.myOpenTickets'), icon: 'mdi-pin' },
        { id: 2, text: this.$t('message.tickets.unassignedTickets'), icon: 'mdi-pin' },
        { id: 3, text: this.$t('message.tickets.closed'), icon: 'mdi-pin' },
        { id: 4, text: this.$t('message.tickets.allTickets'), icon: 'mdi-pin' }
      ]
    },
    listOfMailBoxForFilter () {
      let list = this.$formatter.cloneVariable(this.listOfUserGroupMailboxes)
      list.splice(0, 0, { mailboxid: 0, mailboxname: this.$t('message.tickets.all') })
      return list
    },
    addToSelected (event, item) {
      if (event) {
        this.selected.push(item)
      } else {
        const result = this.selected.filter(x => x.id !== item.id)
        if (result) {
          this.selected = result
        }
      }
    }
  },
  watch: {
    mailbox (val) {
      window.localStorage.setItem('ticketmailbox', val)
      this.$root.$emit('mailboxChanged', val)
    },
    selectedTab (val) {
      this.$root.$emit('tabChanged', val)
      window.localStorage.setItem('tickettab', val)
      this.reRender+1
    }
  },
  mounted () {
    if (!window.localStorage.getItem('tickettab')) {
      this.selectedTab = 'tab-0'
      window.localStorage.getItem('tickettab')
    } else this.selectedTab = window.localStorage.getItem('tickettab')
    this.$store.dispatch('getUserGroupMailbox')
    this.$store.dispatch('getPriority')
    this.$store.dispatch('getStatus')
    this.$store.dispatch('getUsers')
    setTimeout(() => {
      this.$root.$emit('tabChanged', this.selectedTab)
    }, 200)
    this.$root.$on('showStatusDialog', (data) => {
      this.cancloseDialog = true
      this.archiveItem = data
    })
    this.$root.$on('enableorDisableTab', (data) => {
      this.istabDisabled = data
    })
    this.$eventBus.$on('HasNewlyAssignedTickets', () => {
      this.showNewTicketBanner = true
    })
    this.$eventBus.$on('HasNewOrUpdatedTickets', () => {
      this.showNewTicketBanner = true
    })
  },
  methods: {
    menuActions (value) {
      if (value) {
        switch (value) {
          case 'merge':
            this.mergeDialogHandler()
            break
          case 'createTask':
            this.$router.push({ path: '/tickets/create', query: { type: 'task' } })
            break
          case 'changeStatus':
            this.actionsHandler('statusDialog')
            break
          case 'changePriority':
            this.actionsHandler('priorityDialog')
            break
          case 'assignTo':
            this.actionsHandler('assignedDialog')
            break
          case 'delete':
            this.actionsHandler('deleteDialog')
        }
      }
    },
    mergeDialogHandler () {
      if (this.$refs.tabitem.selected.length >= 2) {
        const items = this.$formatter.cloneVariable(this.$refs.tabitem.selected)
        this.mergeItems = items
        this.mergeTicketDialog = true
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text:  this.$t('message.tickets.selectTickets') })
      }
    },
    closeConfirmDialog () {
      if (this.archiveItem.id) {
        this.$root.$emit('closeEdit', { ticketid: this.archiveItem.id })
      }
      this.cancloseDialog = false
    },
    actionsHandler (type) {
      let list = this.$formatter.cloneVariable(this.listOfUsers)
      let groups = this.$formatter.cloneVariable(this.$refs.tabitem.listOfGroups)
      let users = [ ...list, ...groups ]
      this.usersAndGroupsList = users
      if (this.$refs.tabitem.selected.length > 0) this[type] = true
      else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text:  this.$t('message.tickets.selectTickets') })
    },
    mergeTicketHandler () {
      const model = {}
      model.parentticketid = this.parentticketid
      model.childticketids = this.mergeItems.filter(x => x.id !== model.parentticketid).map(x => x.id)
      this.$_executeApi('post', 'mails/merge_mail', model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  this.$t('message.tickets.mergeSuccess') })
        this.closeMergeDialogHandler()
        this.$root.$emit('loadTickets')
      })
    },
    closeMergeDialogHandler () {
      this.mergeItems = []
      this.parentticketid = 0
      this.mergeTicketDialog = false
    },
    // changeStatus () {
    //   this.cancloseLoading = true
    //   if (this.$refs.tabitem.selected.length === 0) {
    //     let status = this.listOfTicketStatus.find(x => x.id === this.archiveItem.status)
    //     let model = { status:  this.archiveItem.status, assignedto: (this.userDetails ? this.userDetails.id : 0) }
    //     this.$_executeApi('put', `tickets/${this.archiveItem.id}`, model).then(response => {
    //       this.cancloseDialog = false
    //       // this.$_executeApi('post', `mfiles/archive`, data).then(response => {
    //       //   this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  'Archeived Succesfully' })
    //       //   this.cancloseDialog = false
    //       // }).finally(() => {
    //       //   this.cancloseLoading = false
    //       // })
    //       this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  this.$t('message.common.updatedSuccess') })
    //       let msg =  `Status set to ${status.name} for ${this.archiveItem.number} by ${this.userDetails.name}`
    //       if (this.archiveItem.assignedto) {
    //         let assignedTo = this.archiveItem.assignedto.split('_')
    //         if (this.$store.userDetails.id !== this.archiveItem.assignedto)  this.getsignalRConnection.invoke('SendNotification', [parseInt(assignedTo[1])], msg, this.archiveItem.id)
    //       }
    //       this.archiveItem = {}
    //       this.$root.$emit('loadTickets')
    //     })
    //   } else {
    //     this.cancloseLoading = true
    //     this.changedStatusHandler()
    //   }
    // },
    changedStatusHandler (setCurrentUser) {
      const model = {}
      let idsArray = this.$refs.tabitem.selected
      model.ids = idsArray.map(x => x.id)
      model.parameters = { status: this.changedStatusId, assignedto: setCurrentUser ? this.userDetails.id : undefined }
      let status = this.listOfTicketStatus.find(x => x.id === this.changedStatusId)
      this.$_executeApi('put', 'tickets/bulk_update', model).then(response => {
        if (status && status.canclose) {
          this.cancloseDialog = false
          // this.$_executeApi('post', `mfiles/archive_bulk`, data).then(response => {
          //   this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  'Archeived Succesfully' })
          //   this.cancloseDialog = false
          // }).finally(() => {
          //   this.cancloseLoading = false
          // })
        }
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  this.$t('message.common.updatedSuccess') })
        idsArray.forEach(element => {
          let msg =  `Status set to ${status.name} for ${element.number} by ${this.$store.state.userDetails.name}`
          if (this.$store.state.userDetails.id !== element.assignedto) {
            this.$eventBus.$emit('SendNotification', [element.assignedto], msg, element.id)
          }
        })
        this.closeStatusDialogHandler()
        this.$root.$emit('loadTickets')
      })
    },
    closeStatusDialogHandler () {
      this.changedStatusId = 0
      this.statusDialog = false
    },
    changedPriorityHandler () {
      const model = {}
      let idsArray = this.$refs.tabitem.selected
      model.ids = idsArray.map(x => x.id)
      model.parameters = { priority: this.changedPriorityId }
      let priority = this.listOfTicketPriorities.find(x => x.id === this.changedPriorityId)
      this.$_executeApi('put', 'tickets/bulk_update', model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
         idsArray.forEach(element => {
          let msg =  `Priority set to ${priority.name} for ${element.number} by ${this.$store.state.userDetails.name}`
          if (this.$store.state.userDetails.id !== element.assignedto) {
            this.$eventBus.$emit('SendNotification', [element.assignedto], msg, element.id)
          }
        })
        this.closePriorityDialogHandler()
         this.$root.$emit('loadTickets')
      })
    },
    closePriorityDialogHandler () {
      this.changedPriorityId = 0
      this.priorityDialog = false
    },
    changeAssignedtoHandler () {
      let assignedToModel = {}
      let model = {}
      let idsArray = this.$refs.tabitem.selected
      let assignedTo = this.assignedtoId.split('_')
      if (assignedTo[0] === 'user') {
        assignedToModel.assignedto = parseInt(assignedTo[1])
        assignedToModel.assignedto_group = null
      } else {
        assignedToModel.assignedto_group = parseInt(assignedTo[1])
        assignedToModel.assignedto = null
      }
      model.ids = idsArray.map(x => x.id)
      model.parameters = assignedToModel
      this.$_executeApi('put', 'tickets/bulk_update', model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text:  this.$t('message.common.updatedSuccess') })
        this.closeAssignedtoDialogHandler()
        idsArray.forEach(element => {
          let  msg = `${this.$t('message.tickets.assignedtoMessage')} ${element.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
          if (this.$store.state.userDetails.id !== model.parameters.assignedto) {
            this.$eventBus.$emit('SendNotification', [parseInt(model.parameters.assignedto)], msg, element.id)
          }
        })
        this.$root.$emit('loadTickets')
      })
    },
    closeAssignedtoDialogHandler () {
      this.assignedtoId = 0
      this.assignedDialog = false
    },
    deleteHandler () {
      let array = this.$refs.tabitem.selected
      const ids = array.map(x => x.id)
      let modelObj = { data: { ids: ids, delete_mails: this.deleteMails } }
      this.$_executeApi('delete', `${this.MODULE_URL}/delete_multiple`, modelObj)
        .then(response => {
          if (response && response.data) {
            let text = this.$t('message.common.deleteSuccess')
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
           this.closeDeleteDialogHandler()
          this.$root.$emit('loadTickets')
          }
        })
    },
    closeDeleteDialogHandler () {
      this.deleteMails = false
      this.deleteDialog = false
    },
    loadTicketHandler () {
      this.$root.$emit('loadTickets')
      this.showNewTicketBanner = false
    }
  },
  beforeDestroy () {
    this.$root.$off('enableorDisableTab')
    this.$root.$off('showStatusDialog')
    this.$eventBus.$off('HasNewlyAssignedTickets')
    this.$eventBus.$off('HasNewOrUpdatedTickets')
  }
}
</script>
<style>
.newticket-banner .v-banner__wrapper {
  padding: 0 !important;
}
</style>
